module.exports = __webpack_public_path__ + "img/1696315135323-WhatsApp Image 2023-10-03 at 14.34.59.jpeg.af30a018.webp";